import { Injectable } from "@angular/core";
import { OntologyAnnotation } from "@bioconnect-ui/curation-service";
import { ContextData } from "@bioconnect-ui/file-service";
import { QuantityKind } from "@bioconnect-ui/measure-service";
import { Comment } from "@bioconnect-ui/shared-service";
import { ResourceCategory, ResourceRole } from "@bioconnect-ui/resource-service";

  export interface ProtocolServiceConfig {
    restServer: string;
  }

  export interface ProtocolResourceCategory {
    id?: number;
    protocol_id?: number;
    role?: ResourceRole;
    category_id?: number;
    category?: ResourceCategory;
    count?: number;
  }

  export interface Protocol {
    id?: number;
    name: string;
    description: string;
    version: string;
    context_data: ContextData[];
    protocol_type?: OntologyAnnotation;
    protocol_type_id?: number;
    parameter_groups?: ParameterGroup[];
    protocol_steps?: ProtocolStep[];
    resource_categories?: ProtocolResourceCategory[];
    owner?: string;
    comments?: Comment[];
    created_by?: string;
    date_created?: Date;
    investigations?: { id: number, identifier: string, title?: string }[];
  }

  export interface ProtocolStep {
    id?: number;
    protocol_id?: number;
    description: string;
    order: number;
  }

  export enum ParameterDataType {
    TEXT = 'text',
    NUMBER = 'number',
    DATE = 'date',
    BOOLEAN = 'boolean',
    SINGLE_SELECT = 'single_select',
    MULTI_SELECT = 'multi_select',
  }

  export interface ParameterGroup {
    id?: number;
    name: string;
    protocol_id?: number;
    parameters?: ProtocolParameter[];
  }

  export interface ProtocolParameter {
    id?: number;
    parameter_name?: string;
    ontology_annotation?: OntologyAnnotation;
    ontology_annotation_id?: number;
    data_type: ParameterDataType;
    quantity_kind?: QuantityKind;
    quantity_kind_id?: number;
    default_value?: string | number | boolean | string[];
    order?: number;
    required: boolean;
    group_id?: number;
    enum_values?: ProtocolParameterEnum[];
  }

  export interface ProtocolParameterEnum {
    id?: number;
    parameter_id?: number;
    value: string;
    ontology_annotation?: OntologyAnnotation;
    ontology_annotation_id?: number;
    order?: number;
  }


@Injectable({
  providedIn: 'root',
})

export class ProtocolServiceTypes {

}